import { render, staticRenderFns } from "./page-table.vue?vue&type=template&id=5db52c7b&scoped=true"
import script from "./page-table.vue?vue&type=script&lang=js"
export * from "./page-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db52c7b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5db52c7b')) {
      api.createRecord('5db52c7b', component.options)
    } else {
      api.reload('5db52c7b', component.options)
    }
    module.hot.accept("./page-table.vue?vue&type=template&id=5db52c7b&scoped=true", function () {
      api.rerender('5db52c7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataCenter/source/components/page-table.vue"
export default component.exports